import { useState, useRef, useEffect } from 'react';
import stringHelpers from '../../utilities/stringHelpers';
import { TimeRangeDragHandle } from './timeRangeDragHandle';
export const TimeRangeSlider = ({ startTime: initialStartTime, endTime: initialEndTime, onChange }) => {

    const [startTime, setStartTime] = useState(stringHelpers.formatTimeStringToMinutes(initialStartTime));
    const [endTime, setEndTime] = useState(stringHelpers.formatTimeStringToMinutes(initialEndTime));
    const [isDragging, setIsDragging] = useState(null);
    const sliderRef = useRef(null);

    useEffect(() => {
        stringHelpers.formatTimeStringToMinutes(initialStartTime)
    }, [initialStartTime]);

    useEffect(() => {
        stringHelpers.formatTimeStringToMinutes(initialEndTime)
    }, [initialEndTime]);

    useEffect(() => {
        if (onChange) {
            onChange({
                startTime: stringHelpers.formatMinutesToTwentyFourHourClock(startTime),
                endTime: stringHelpers.formatMinutesToTwentyFourHourClock(endTime)
            });
        }
    }, [startTime, endTime]);

    const handleMouseDown = (handle) => (e) => {
        setIsDragging(handle);
        e.preventDefault();
    };

    const handleMouseMove = (e) => {
        if (!isDragging || !sliderRef.current) return;

        const rect = sliderRef.current.getBoundingClientRect();
        const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
        const minutes = Math.round((x / rect.width) * 1440);

        if (isDragging === 'start') {
            setStartTime(minutes % 1440);
        } else {
            setEndTime(minutes % 1440);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(null);
    };

    useEffect(() => {
        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isDragging, startTime, endTime]);


    return (
        <div className="position-relative">
            <div className="d-flex small text-muted mb-2">
                { [0, 3, 6, 9, 12, 15, 18, 21].map(h => (
                    <div key={ h } style={ { width: '12.5%' } }>
                        { `${ String(h).padStart(2, '0') }:00` }
                    </div>
                )) }
            </div>
            <div ref={ sliderRef } className="position-relative rounded-pill range-slider-track">
                <div
                    className="position-absolute bg-primary rounded-pill"
                    style={ {
                        height: '100%',
                        left: endTime >= startTime ? `${ (startTime / 1440) * 100 }%` : '0%',
                        right: endTime >= startTime ? `${ 100 - (endTime / 1440) * 100 }%` : `${ 100 - (endTime / 1440) * 100 }%`,
                        display: endTime >= startTime ? 'block' : 'none',
                        pointerEvents: 'none'
                    } }
                />
                { endTime < startTime && (
                    <>
                        <div
                            className="position-absolute bg-primary"
                            style={ {
                                height: '100%',
                                left: `${ (startTime / 1440) * 100 }%`,
                                right: '0%',
                                borderRadius: '50px 0 0 50px',
                                pointerEvents: 'none'
                            } }
                        />
                        <div
                            className="position-absolute bg-primary"
                            style={ {
                                height: '100%',
                                left: '0%',
                                right: `${ 100 - (endTime / 1440) * 100 }%`,
                                borderRadius: '0 50px 50px 0',
                                pointerEvents: 'none'
                            } }
                        />
                    </>
                ) }

                <TimeRangeDragHandle 
                    handleMouseDown={() => handleMouseDown('start')}
                    isDragging={isDragging}
                    timeValue={startTime}
                    backgroundColourUtility="success"
                    minusOneUnit={() => setStartTime(prevState => --prevState)}
                    plusOneUnit={() => setStartTime(prevState => ++prevState)}
                    key="start-drag-handle"
                />

                <TimeRangeDragHandle 
                    handleMouseDown={() => handleMouseDown('end')}
                    isDragging={isDragging}
                    timeValue={endTime}
                    backgroundColourUtility="danger"
                    minusOneUnit={() => setEndTime(prevState => --prevState)}
                    plusOneUnit={() => setEndTime(prevState => ++prevState)}
                    key="end-drag-handle"
                />
            </div>
        </div>
    );
};